<template>
  <div class="d-flex flex-column container-xxl py-60 ps-0 px-0">
    <h2 class="heading-section-2 text-dark text-center mb-0">
      {{ title }}
    </h2>
    <div class="profile-card-slider position-relative">
      <Swiper
        class="vacancy-carousel swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden"
        :modules="[ SwiperNavigation ]"
        :navigation="{ nextEl: '.vacancy-carousel-next', prevEl: '.vacancy-carousel-prev', disabledClass: 'disabled' }"
        :slides-per-view="1"
        :breakpoints="{ 768: { slidesPerView: 2}, 1200: { slidesPerView: 3 }, 1400: { slidesPerView: 4 } }"
      >
        <SwiperSlide
          v-for="(vacancy, index) in vacancies.items"
          class="swiper-slide swiper-slide-duplicate"
        >
          <div class="job-card-grid custom-card">
            <div class="custom-body">
              <div class="job-dropdown">
                <button
                  class="job-dropdown-btn d-none"
                  type="button"
                  aria-expanded="false"
                >
                  <svg
                    class="svg-inject svg-icon"
                    height="20"
                    width="20"
                  >
                    <use xlink:href="/public/icons/main.svg#more" />
                  </svg>
                </button>
                <ul
                  class="dropdown-menu dropdown-menu-end"
                  aria-labelledby="job-featured-dropdown"
                >
                  <li>
                    <NuxtLink
                      class="dropdown-item"
                      to="#"
                    >
                      Dropdown 1
                    </NuxtLink>
                  </li>
                  <li>
                    <NuxtLink
                      class="dropdown-item"
                      to="#"
                    >
                      Dropdown 2
                    </NuxtLink>
                  </li>
                </ul>
              </div>
              <div class="job-info">
                <div class="job-image">
                  <img
                    :src="vacancy.company.logo"
                    :alt="vacancy.company.title"
                    style="object-fit: contain"
                  >
                </div>
                <h5 class="job-title">
                  <NuxtLink :to="`/vacancies/${vacancy.id}`">
                    {{ vacancy.profession.title }}
                  </NuxtLink>
                </h5>
                <div class="job-author">
                  <NuxtLink
                    :to="'/companies/' + vacancy.company.id"
                  >
                    {{ vacancy.company.name }}
                  </NuxtLink>
                </div>
              </div>
              <ul class="job-detail">
                <li class="job-detail-item justify-content-md-between justify-content-center">
                  <div class="job-detail-start">
                    <svg
                      class="svg-inject svg-icon"
                      height="20"
                      width="20"
                    >
                      <use xlink:href="/public/icons/main.svg#account-balance-wallet" />
                    </svg>
                  </div>
                  <div class="job-detail-center ms-md-0 ms-5">
                    <div class="job-detail-text">
                      {{ getSalary(vacancy.salary.min, vacancy.salary.max) }}
                    </div>
                  </div>
                  <div class="job-detail-end">
                    <div
                      v-show="!(vacancy.salary.min === null && vacancy.salary.max === null)"
                      class="job-detail-text"
                      href="#"
                    >
                      /месяц
                    </div>
                  </div>
                </li>
                <li class="job-detail-item justify-content-md-between justify-content-center">
                  <div class="job-detail-start">
                    <svg
                      class="svg-inject svg-icon"
                      height="20"
                      width="20"
                    >
                      <use xlink:href="/public/icons/main.svg#location-on" />
                    </svg>
                  </div>
                  <div class="job-detail-center">
                    <div class="job-detail-text">
                      {{ vacancy.address }}
                    </div>
                  </div>
                </li>
                <li class="job-detail-item justify-content-center">
                  <time>
                    {{ new Date(vacancy.created * 1000).toLocaleDateString(['ru-RU', 'en-US'], {day: '2-digit', month: '2-digit', year: 'numeric'}) }}
                  </time>
                </li>
              </ul>
            </div>
            <div class="job-action custom-action justify-content-center">
              <AppButton
                variant
                :active="vacancy.favorite === null"
                class="btn-book flex-shrink-0"
                :class="vacancy.favorite === null ? 'border booked' : null"
                title="Добавить в избранное"
                is-icon
                @click.stop="favoriteControl(index)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  data-inject-url="https://peterdraw.studio/ziro-html/assets/icons/heart.svg"
                  class="svg-inject svg-icon"
                >
                  <path d="M14.6875 2C12.3186 2 10.7965 3.55012 10 4.94285C9.20348 3.55012 7.68145 2 5.3125 2C2.30613 2 0 4.30254 0 7.35641C0 10.6678 2.88922 12.9228 7.20363 16.3371C9.31621 18.0075 9.45195 18.1345 10 18.575C10.4473 18.2155 10.6948 17.9988 12.7964 16.3371C17.1108 12.9228 20 10.6678 20 7.35641C20 4.30258 17.6939 2 14.6875 2Z" />
                </svg>
              </AppButton>
              <AppButton
                class="fw-bold"
                :disabled="vacancy.response !== null"
                :variant="BtnVariant.Tertiary"
                @click="respond(index)"
              >
                {{ vacancy.response === null ? 'Откликнуться' : 'Вы откликнулись' }}
              </AppButton>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div
        class="vacancy-carousel-prev profile-card-button-prev btn"
        tabindex="0"
        role="button"
        aria-label="Previous slide"
      >
        <svg
          style="rotate: 180deg"
          class="svg-inject svg-icon"
        >
          <use xlink:href="/public/icons/main.svg#east" />
        </svg>
      </div>
      <div
        class="vacancy-carousel-next profile-card-button-next btn"
        tabindex="0"
        role="button"
        aria-label="Next slide"
      >
        <svg class="svg-inject svg-icon">
          <use xlink:href="/public/icons/main.svg#east" />
        </svg>
      </div>
    </div>
    <NuxtLink
      class="d-none btn btn-primary btn-rounded mx-auto"
      to="#"
    >
      Все вакансии
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { useApiFavorite } from "~/composables/api/favorite";
import {useClient} from "~/stores/client";
import {BtnVariant} from "~/composables/enums/BtnVariant";
import type { PropType } from "vue";

const client = useClient();
const apiFavorite = useApiFavorite(client.getClientId);

const emits = defineEmits(['addFavorite', 'removeFavorite', 'response']);
const props = defineProps({
  title: {type: String, default: ''},
  vacancies: {type: Object as PropType<any>, default: () => ({})},
});

//-----METHODS-----\\
async function respond(index: number) {
  if (!client.isAuthenticated) {
    //TODO: предлагать аторизоваться
    return;
  }

  await mainFetch('responses', {
    method: 'POST',
    body: { vacancy: props.vacancies.items[index].id }
  }).then((response) => {
    if (response.status.value !== "success") {
      return;
    }

    emits('response', index, response.data.value.response.id);
  });
}
function getSalary(min: number|null = null, max: number|null = null) {
  if (min === null && max === null) {
    return 'Зарплата не указана';
  } else if (min !== null && max !== null) {
    return min + ' - ' + max + ' руб.';
  } else if (max === null) {
    return 'от ' + min + ' руб.';
  } else if (min === null) {
    return 'до ' + max + ' руб.';
  }
}
async function favoriteControl(index: number) {
  if (!client.isAuthenticated) {
    //TODO: предлагать аторизоваться
    return;
  }

  props.vacancies.items[index].favorite;
  if (props.vacancies.items[index].favorite === null) {
    const id: string|null = await apiFavorite.add(props.vacancies.items[index].id as string, 1);
    if (id !== null) {
      emits('addFavorite', index, id);
    }
    return;
  }

  const isAdded: boolean = await apiFavorite.delete(props.vacancies.items[index].favorite.id);
  if (isAdded) {
    emits('removeFavorite', index);
  }
}
</script>

<style scoped lang="scss">
  @media (min-width: 361px) {
    .custom-card {
      padding: 40px 30px;
    }
  }

  @media (max-width: 360px) {
    .custom-card {
      padding: 40px 0;

      .custom-body {
        padding: 0 30px;
      }
      .custom-action {
        padding: 0 10px;
      }
    }
  }
</style>
